import React from 'react';

const BroadcastInfo = ({game}) => {

    const gameBroadcasts = game.gameBroadcast && game.gameBroadcast.length > 0 ? game.gameBroadcast : [];

    const countrySortedBroadcastList = () => {
        const canadianTeamIds = [8,9,10,20,22,23,32,33,36,37,41,42,43,57,58,52]; //horrible way of doing this. temporary
        const isCanadian = canadianTeamIds.includes(game.homeTeam.id);

        const sorted = gameBroadcasts
            .filter((broadcast) => broadcast.broadcastMarket !== 'I')
            .sort((a,b) =>
                (a.gameNetwork.countryCode < b.gameNetwork.countryCode) ? -1 :
                    (a.gameNetwork.countryCode > b.gameNetwork.countryCode) ? 1 : 0);

        return isCanadian ? sorted : sorted.slice(0).reverse();
    };

    const renderBroadcastInfo = () => {
        return countrySortedBroadcastList().map(broadcast => broadcast.gameNetwork.network).join(", ");
    };

    return <span className="networks">{renderBroadcastInfo()}</span>
};

export default BroadcastInfo;